export default "__VITE_ASSET__C0RVvi$1__"